import { t } from "i18next";

import CreateIcon from "@mui/icons-material/Create";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import EmailIcon from "@mui/icons-material/Email";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ShareIcon from "@mui/icons-material/Share";

export const dataOptions = [
  {
    icon: <CreateIcon />,
    text: "dashboard.edit_association",
    link: "edit-association",
  },
  {
    icon: <AddCircleOutlineIcon />,
    text: "dashboard.create_event",
    link: "create-event",
  },
  {
    icon: <CalendarMonthOutlinedIcon />,
    text: "dashboard.calendar",
    link: "/calendar?admin={{id_association}}",
  },
  {
    icon: <NewspaperIcon />,
    text: "dashboard.view_event",
    link: "list-events",
  },
  {
    icon: <NotificationImportantIcon />,
    text: "dashboard.request_volunteer",
    link: "list-volunteers",
  },
  {
    icon: <NotificationImportantIcon />,
    text: "dashboard.request_shift",
    link: "request-shift",
  },
  {
    icon: <MarkUnreadChatAltIcon />,
    text: "dashboard.send_notification",
    link: "send-notification",
  },
  {
    icon: <QuestionMarkIcon />,
    text: "dashboard.question",
    link: "list-question",
  },
  {
    icon: <EmailIcon />,
    text: "dashboard.sended_notification",
    link: "notifications-board-association",
  },
  {
    icon: <ShareIcon />,
    text: "dashboard.volunteer_invitation",
    link: null,
  },
];
